import React, { useState } from 'react'
import { useActions, useValues } from 'kea'
import I18n from 'lib/i18n'

import logic from './logic'
import Tabs from './tabs'
import Questions from './questions'
import SearchForm from './search-form'
import Faq from './faq'

import Contact from '../pages/contact'

export default function Faqs () {
  const { questionType, faq, searchedFaqs } = useValues(logic)
  const { setQuestionTypeParam } = useActions(logic)
  const [isVisibleContact, showContact] = useState(false)

  const MoreHelp = () => (
    <div className='twelve columns more-help-container'>
      <h2 className='more-help-title'>{I18n.t('faqs.index.more_help')}</h2>
      <a className='show-contact-button' onClick={() => showContact(true)}>
        {I18n.t('faqs.index.show_contact')}
      </a>
    </div>
  )

  return (
    <div className='row'>
      <div className='twelve columns'>
        <h1 className='page-title'>
          <a onClick={() => setQuestionTypeParam(questionType)}>{I18n.t('faqs.index.left_title')}</a>
        </h1>
      </div>
      <div className='twelve columns'>
        <Tabs />
        <div className='widget space' style={{ borderTop: 'none' }}>
          <div className='inline-search-bar clearfix'>
            {faq ? (
              <Faq />
            ) : (
              <div>
                <SearchForm />
                <h2
                  className='faqs-index-title'
                  style={{
                    marginBottom: 15
                  }}
                >
                  {searchedFaqs ? I18n.t('faqs.index.search_results_title') : I18n.t('faqs.index.title')}
                </h2>
                <Questions />
              </div>
            )}
          </div>
        </div>
      </div>
      {!isVisibleContact && <MoreHelp showContact={showContact} />}
      {isVisibleContact && <Contact />}
    </div>
  )
}
